import {cn} from '../../lib/utils';
import {Typography} from '../Typography';

import type {FC, ReactNode} from 'react';

export interface InfoRowProps {
  label: string;
  value: ReactNode;
  layout?: 'horizontal' | 'vertical';
  size?: 'xs' | 'sm' | 'md';
  valueSize?: 'xs' | 'sm' | 'md';
  valueWeight?: 'semibold' | 'bold';
  mono?: boolean;
  dir?: 'ltr' | 'rtl';
  className?: string;
}

export const InfoRow: FC<InfoRowProps> = ({
  label,
  value,
  layout = 'horizontal',
  size = 'sm',
  valueSize,
  valueWeight = 'semibold',
  mono,
  dir,
  className
}) => {
  if (layout === 'vertical') {
    return (
      <div data-slot="info-row" className={cn('flex flex-col gap-1', className)}>
        <Typography size="xs" color="tertiary">
          {label}
        </Typography>
        <Typography size={valueSize ?? size} dir={dir} className={cn(mono && 'font-mono')}>
          {value}
        </Typography>
      </div>
    );
  }

  return (
    <div data-slot="info-row" className={cn('flex items-center justify-between', className)}>
      <Typography size={size} color="tertiary">
        {label}
      </Typography>
      <Typography
        size={valueSize ?? size}
        weight={valueWeight}
        dir={dir}
        className={cn(mono && 'font-mono')}
      >
        {value}
      </Typography>
    </div>
  );
};
